import axios from 'axios';

const updateSettings = params => axios.put('viber/settings', params);

const acceptPolicy = () => axios.put('viber/settings/accept');

export { updateSettings, acceptPolicy };
